import { Button, Col, Row } from "react-bootstrap";
import Card from "../../../../components/Cards/Basic";
import { Form, Formik } from "formik";
import FormInputText from "../../../../components/Forms/FormInputText";
import FormSelectBox from "../../../../components/Forms/FormSelectBox";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../../config/axios";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/Toasts";
import { keepState } from "../../../../components/UiComponents/Buttons/BackButton/helper";
import history from "../../../../global/history";
import BackButton from "../../../../components/UiComponents/Buttons/BackButton";
import { useTranslation } from "react-i18next";
import { DashboardContext } from "../../../../routes/DashboardRoutes";
import { localeOptions } from "../../../../global";

const EditStayPage = () => {
  function validate(values) {
    const errors = {};
    return errors;
  }

  const { id } = useParams();

  const [stay, setStay] = useState();
  const { settings, configuration, locales } = useContext(DashboardContext);
  const { t } = useTranslation("dashboard");
  const formRef = useRef();

  useEffect(() => {
    getStay();
  }, []);

  const getStay = () => {
    axios
      .get(`/api/v1/stays/${id}.json`)
      .then(function (response) {
        setStay(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function submit(values, helpers) {
    helpers.setSubmitting(true);

    if (values.state === "draft") {
      values.state = "default";
    }

    let request = axios.put(`/api/v1/stays/${stay.id}.json`, { stay: values });

    request
      .then(function (response) {
        history.push(`/dashboard/stays/${id}`, keepState(history));
        showSuccessToast();
      })
      .catch((error) => {
        helpers.setErrors(error.response.data);
      })
      .finally(() => helpers.setSubmitting(false));
  }

  const fillForm = () => {
    const form = {};

    form.id = stay?.id || "";
    form.nfc_card_uid = stay?.nfc_card_uid;
    form.contact_first_name = stay?.contact_first_name;
    form.contact_last_name = stay?.contact_last_name;
    form.contact_phone = stay?.contact_phone;
    form.contact_email = stay?.contact_email;
    form.state = stay?.state;
    form.language = stay?.language ?? "";

    return form;
  };

  if (!settings) {
    return <></>;
  }

  return (
    <Row>
      <Col>
        <Card
          title={
            <div className="d-flex w-100 align-items-center text-center">
              <>
                <BackButton fallbackRoute={`/dashboard/stays/${id}`} />{" "}
                <p className="mb-0">Aufenthalt</p>
              </>
            </div>
          }
        >
          <Formik
            initialValues={fillForm()}
            innerRef={formRef}
            enableReinitialize={true}
            validate={validate}
            onSubmit={submit}
          >
            {({ values, setFieldValue }) => (
              <Form autoComplete="false">
                <FormInputText name="contact_first_name" label="Vorname" />
                <FormInputText name="contact_last_name" label="Nachname" />
                <FormInputText name="contact_phone" label="Telefonnummer" />
                <FormInputText name="contact_email" label="E-Mail" />

                <FormSelectBox
                  name="language"
                  label="Sprache"
                  hint="Diese Sprache wird beim Automat, E-Mails und weiteren Geräten standardmäßig ausgewählt. "
                  options={localeOptions(configuration, locales)}
                  option_value="locale"
                />

                <FormInputText
                  name="nfc_card_uid"
                  label="NFC Kartennummer"
                  hint="Die Kartennummer kann mit einem NFC Lesegerät ausgelesen werden"
                  required
                />
                <Button variant="primary" type="submit">
                  {t("common:components:button.save")}
                </Button>
              </Form>
            )}
          </Formik>
        </Card>
      </Col>
    </Row>
  );
};

export default EditStayPage;
